<template>
    <div :class="'img-' + size" class="custom-icon">
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M118 19c5.523 0 10 4.477 10 10v27h0a9 9 0 100 18v28c0 5.523-4.477 10-10 10H12c-5.523 0-10-4.477-10-10V74h0a9 9 0 000-18V29c0-5.523 4.477-10 10-10h106z" class="path" stroke="#0C2340"/><rect class="highlight" stroke="#00BBDC" x="25" y="41" width="80" height="48" rx="5"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>